// removed by extract-text-webpack-plugin
module.exports = {"header":"_2gDK2","headertext":"HRFUv","title":"_1ZOkN","subtitle":"_1aGcM","content":"ATCLS","root":"_3FIiq","overlay":"_2Yq1E","card":"DPzxS","cardLayout":"_2hgu6","buttonClose":"_3jWZr"};


//////////////////
// WEBPACK FOOTER
// ./components/DialogPlan/styles.scss
// module id = 757
// module chunks = 0